'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QS_TYPES = undefined;
exports.inSameBlock = inSameBlock;
exports.filterQsByBlock = filterQsByBlock;
exports.orderedQs = orderedQs;
exports.filterQsByType = filterQsByType;
exports.seqToJs = seqToJs;
exports.nextQs = nextQs;

var _immutable = require('immutable');

var TYPE_ORDER = {
  'intro': 0,
  'question': 1, 'text': 1, 'form': 1,
  'activity_summary': 2,
  'result_email': 3
};

var QS_TYPES = exports.QS_TYPES = Object.keys(TYPE_ORDER);

function inSameBlock(a, b) {
  return TYPE_ORDER[a.get('type')] === TYPE_ORDER[b.get('type')];
}

var sortCompare = function sortCompare(a, b) {
  var result = TYPE_ORDER[a.get('type')] - TYPE_ORDER[b.get('type')];
  if (result === 0) {
    result = a.get('pos') - b.get('pos');
  }
  return result;
};

function filterQsByBlock(qs, aTypeInBlock) {
  var blockNo = TYPE_ORDER[aTypeInBlock];
  var types = Object.keys(TYPE_ORDER).filter(function (t) {
    return TYPE_ORDER[t] === blockNo;
  });
  return filterQsByType(qs, types);
}

function orderedQs(qs) {
  return filterQsByType(qs, QS_TYPES);
}

function filterQsByType(qs, type) {
  var includedTypes = Array.isArray(type) ? type : [type];
  return !qs ? new _immutable.Seq() : qs.filter(function (q) {
    return includedTypes.find(function (t) {
      return q.get('type') === t;
    });
  }).sort(sortCompare);
}

function seqToJs(seq) {
  return seq.toArray().map(function (q) {
    return q.toJS();
  });
}

function nextQs(qs, currentQsId) {
  var qsCurrentAndAfter = orderedQs(qs).skipUntil(function (qs) {
    return qs.get('id') === currentQsId;
  }).toIndexedSeq();
  return qsCurrentAndAfter && qsCurrentAndAfter.size > 1 ? qsCurrentAndAfter.get(1) : null;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-data/lib/index.js
// module id = 878
// module chunks = 0